import { Button, Flex } from "antd"
import { spacings } from "themes/variables"
import { Text } from "ui/Typography"
import styles from "../index.module.css"
import PropTypes from "prop-types"
import BookingConflictWarning from "pagesV2/pro/Calendar/Tooltips/BookingConflictWarning"

const EventBlock = ({
  event,
  stackOffset,
  topPct,
  heightPct,
  stackIdx,
  eventColor,
  eventBorderColor,
  conflict,
  setIsBookingModalOpen,
  setSelectedBookingId
}) => {
  const { id, startLabel, endLabel, title, description } = event || {}

  const handleClick = (event) => {
    setIsBookingModalOpen(true)
    setSelectedBookingId(event?.id)
  }

  return (
    <Flex
      key={id || title + startLabel + endLabel}
      vertical
      className={styles.eventBlock}
      gap={spacings.XS}
      style={{
        left: `${stackOffset}px`,
        top: `${topPct}%`,
        height: `${heightPct}%`,
        zIndex: 2 + stackIdx,
        backgroundColor: eventColor,
        border: `1.5px solid ${eventBorderColor}`
      }}
    >
      <Flex align="center" justify="space-between" wrap="wrap">
        <Button onClick={() => handleClick(event)} type="primary" className={`px-xs py-xxs w-fit rounded-xs ${styles.eventTime}`}>
          {startLabel} – {endLabel}
        </Button>
        {conflict ? <BookingConflictWarning /> : null}
      </Flex>
      <Text>{title}</Text>
      {description && <Text>{description}</Text>}
    </Flex>
  )
}

EventBlock.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    startLabel: PropTypes.string,
    endLabel: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string
  }),
  stackOffset: PropTypes.number,
  topPct: PropTypes.number,
  heightPct: PropTypes.number,
  stackIdx: PropTypes.number,
  eventColor: PropTypes.string,
  eventBorderColor: PropTypes.string,
  setIsBookingModalOpen: PropTypes.func,
  setSelectedBookingId: PropTypes.func,
  conflict: PropTypes.bool
}

export default EventBlock
